import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { applyFilters, setCurrentTable } from '@/redux/slices/dataTableSlice';
import styled from '@emotion/styled';
import { Button, Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';

type BundleIdBoxProps = {
  bundleId: string | null | undefined;
  details?: boolean;
};

const BundleIdBox = ({ bundleId, details }: BundleIdBoxProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const currentTable = useAppSelector(selectCurrentTableKey);
  if (!bundleId) {
    return <span>-</span>;
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (currentTable !== 'jobs') dispatch(setCurrentTable('jobs'));
    dispatch(applyFilters({ filters: { filter_id: [bundleId, 'bundle_job_hid_filter'] } }));
    history.push('/jobs');
  };

  return (
    <Tooltip title="View all Jobs in this Bundle" placement="top">
      <StyledButton variant={details ? 'text' : 'outlined'} color="default" size="small" onClick={handleClick} details={details}>
        {bundleId}
      </StyledButton>
    </Tooltip>
  );
};

export default BundleIdBox;

const StyledButton = styled(Button)<{ details?: boolean }>`
  border-color: ${(props) => props.theme.palette.text.primary};
  color: ${(props) => props.theme.palette.text.primary};
  padding: ${(props) => (props.details ? '0 !important' : '0.1rem')};
  justify-content: ${(props) => (props.details ? 'flex-start' : 'center')};
`;
